<template>
  <v-form ref="form" @keyup.enter="onConfirm">
    <v-container class="px-0">
      <rich-text-input
        v-model="fields.instructions"
        @keyup.stop
        :tooltipText="
          $t(
            'warehouse.forms.createWarehouseForm.messages.toBeDisplayedInTheEmailNotificationsAndTheCarrierViewPortal'
          )
        "
        :label="$t('warehouse.forms.createWarehouseForm.messages.instructionsForCarriers')"
        :enabled-modules="{
          bold: false,
          italic: false,
          underline: false,
          link: false
        }"></rich-text-input>
      <warehouse-amenities-ppe-requirements :fields="fields" />
    </v-container>
  </v-form>
</template>

<script>
/**
 * Create Warehouse Form
 * @displayName Create Warehouse Form
 */
export default {
  props: {
    confirmLabel: {
      type: String,
      required: false,
      default: 'Create Warehouse'
    },
    confirmIcon: {
      type: String,
      required: false,
      default: 'plus'
    }
  },
  data() {
    return {
      fields: {
        instructions: '',
        amenities: [],
        ppeRequirements: []
      }
    };
  },
  methods: {
    async onConfirm() {
      if (await this.$isFormValid(this.$refs.form)) {
        this.$emit('confirm', { ...this.fields });
      }
    }
  }
};
</script>
